<template>
  <form @submit.prevent="handleSubmit(item)">
    <div class="form-group">
      <label
        for="exsbowner_createdAt"
        class="form-control-label">createdAt</label>
      <input
        id="exsbowner_createdAt"
        v-model="item.createdAt"
        :class="['form-control', isInvalid('createdAt') ? 'is-invalid' : '']"
        type="dateTime"
        placeholder=""
        @input="handleUpdateField('createdAt', $event.target.value)">
      <div
        v-if="isInvalid('createdAt')"
        class="invalid-feedback">{{ violations.createdAt }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbowner_updatedAt"
        class="form-control-label">updatedAt</label>
      <input
        id="exsbowner_updatedAt"
        v-model="item.updatedAt"
        :class="['form-control', isInvalid('updatedAt') ? 'is-invalid' : '']"
        type="dateTime"
        placeholder=""
        @input="handleUpdateField('updatedAt', $event.target.value)">
      <div
        v-if="isInvalid('updatedAt')"
        class="invalid-feedback">{{ violations.updatedAt }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbowner_deletedAt"
        class="form-control-label">deletedAt</label>
      <input
        id="exsbowner_deletedAt"
        v-model="item.deletedAt"
        :class="['form-control', isInvalid('deletedAt') ? 'is-invalid' : '']"
        type="dateTime"
        placeholder=""
        @input="handleUpdateField('deletedAt', $event.target.value)">
      <div
        v-if="isInvalid('deletedAt')"
        class="invalid-feedback">{{ violations.deletedAt }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbowner_createdBy"
        class="form-control-label">createdBy</label>
      <input
        id="exsbowner_createdBy"
        v-model="item.createdBy"
        :class="['form-control', isInvalid('createdBy') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('createdBy', $event.target.value)">
      <div
        v-if="isInvalid('createdBy')"
        class="invalid-feedback">{{ violations.createdBy }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbowner_updatedBy"
        class="form-control-label">updatedBy</label>
      <input
        id="exsbowner_updatedBy"
        v-model="item.updatedBy"
        :class="['form-control', isInvalid('updatedBy') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('updatedBy', $event.target.value)">
      <div
        v-if="isInvalid('updatedBy')"
        class="invalid-feedback">{{ violations.updatedBy }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbowner_deletedBy"
        class="form-control-label">deletedBy</label>
      <input
        id="exsbowner_deletedBy"
        v-model="item.deletedBy"
        :class="['form-control', isInvalid('deletedBy') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('deletedBy', $event.target.value)">
      <div
        v-if="isInvalid('deletedBy')"
        class="invalid-feedback">{{ violations.deletedBy }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbowner_state"
        class="form-control-label">state</label>
      <input
        id="exsbowner_state"
        v-model="item.state"
        :class="['form-control', isInvalid('state') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('state', $event.target.value)">
      <div
        v-if="isInvalid('state')"
        class="invalid-feedback">{{ violations.state }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbowner_titlePartOne"
        class="form-control-label">titlePartOne</label>
      <input
        id="exsbowner_titlePartOne"
        v-model="item.titlePartOne"
        :class="['form-control', isInvalid('titlePartOne') ? 'is-invalid' : '']"
        type="text"
        required="true"
        placeholder=""
        @input="handleUpdateField('titlePartOne', $event.target.value)">
      <div
        v-if="isInvalid('titlePartOne')"
        class="invalid-feedback">{{ violations.titlePartOne }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbowner_titlePartTwo"
        class="form-control-label">titlePartTwo</label>
      <input
        id="exsbowner_titlePartTwo"
        v-model="item.titlePartTwo"
        :class="['form-control', isInvalid('titlePartTwo') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('titlePartTwo', $event.target.value)">
      <div
        v-if="isInvalid('titlePartTwo')"
        class="invalid-feedback">{{ violations.titlePartTwo }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbowner_contactPerson"
        class="form-control-label">contactPerson</label>
      <input
        id="exsbowner_contactPerson"
        v-model="item.contactPerson"
        :class="['form-control', isInvalid('contactPerson') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('contactPerson', $event.target.value)">
      <div
        v-if="isInvalid('contactPerson')"
        class="invalid-feedback">{{ violations.contactPerson }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbowner_representativePerson"
        class="form-control-label">representativePerson</label>
      <input
        id="exsbowner_representativePerson"
        v-model="item.representativePerson"
        :class="['form-control', isInvalid('representativePerson') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('representativePerson', $event.target.value)">
      <div
        v-if="isInvalid('representativePerson')"
        class="invalid-feedback">{{ violations.representativePerson }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbowner_nip"
        class="form-control-label">nip</label>
      <input
        id="exsbowner_nip"
        v-model="item.nip"
        :class="['form-control', isInvalid('nip') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('nip', $event.target.value)">
      <div
        v-if="isInvalid('nip')"
        class="invalid-feedback">{{ violations.nip }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbowner_phone"
        class="form-control-label">phone</label>
      <input
        id="exsbowner_phone"
        v-model="item.phone"
        :class="['form-control', isInvalid('phone') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('phone', $event.target.value)">
      <div
        v-if="isInvalid('phone')"
        class="invalid-feedback">{{ violations.phone }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbowner_mobilePhone"
        class="form-control-label">mobilePhone</label>
      <input
        id="exsbowner_mobilePhone"
        v-model="item.mobilePhone"
        :class="['form-control', isInvalid('mobilePhone') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('mobilePhone', $event.target.value)">
      <div
        v-if="isInvalid('mobilePhone')"
        class="invalid-feedback">{{ violations.mobilePhone }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbowner_userEmail"
        class="form-control-label">userEmail</label>
      <input
        id="exsbowner_userEmail"
        v-model="item.userEmail"
        :class="['form-control', isInvalid('userEmail') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('userEmail', $event.target.value)">
      <div
        v-if="isInvalid('userEmail')"
        class="invalid-feedback">{{ violations.userEmail }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbowner_street"
        class="form-control-label">street</label>
      <input
        id="exsbowner_street"
        v-model="item.street"
        :class="['form-control', isInvalid('street') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('street', $event.target.value)">
      <div
        v-if="isInvalid('street')"
        class="invalid-feedback">{{ violations.street }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbowner_city"
        class="form-control-label">city</label>
      <input
        id="exsbowner_city"
        v-model="item.city"
        :class="['form-control', isInvalid('city') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('city', $event.target.value)">
      <div
        v-if="isInvalid('city')"
        class="invalid-feedback">{{ violations.city }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbowner_postcode"
        class="form-control-label">postcode</label>
      <input
        id="exsbowner_postcode"
        v-model="item.postcode"
        :class="['form-control', isInvalid('postcode') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('postcode', $event.target.value)">
      <div
        v-if="isInvalid('postcode')"
        class="invalid-feedback">{{ violations.postcode }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbowner_province"
        class="form-control-label">province</label>
      <input
        id="exsbowner_province"
        v-model="item.province"
        :class="['form-control', isInvalid('province') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('province', $event.target.value)">
      <div
        v-if="isInvalid('province')"
        class="invalid-feedback">{{ violations.province }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbowner_country"
        class="form-control-label">country</label>
      <input
        id="exsbowner_country"
        v-model="item.country"
        :class="['form-control', isInvalid('country') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('country', $event.target.value)">
      <div
        v-if="isInvalid('country')"
        class="invalid-feedback">{{ violations.country }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbowner_extraInfo"
        class="form-control-label">extraInfo</label>
      <input
        id="exsbowner_extraInfo"
        v-model="item.extraInfo"
        :class="['form-control', isInvalid('extraInfo') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('extraInfo', $event.target.value)">
      <div
        v-if="isInvalid('extraInfo')"
        class="invalid-feedback">{{ violations.extraInfo }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbowner_bankName"
        class="form-control-label">bankName</label>
      <input
        id="exsbowner_bankName"
        v-model="item.bankName"
        :class="['form-control', isInvalid('bankName') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('bankName', $event.target.value)">
      <div
        v-if="isInvalid('bankName')"
        class="invalid-feedback">{{ violations.bankName }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbowner_bankAccount"
        class="form-control-label">bankAccount</label>
      <input
        id="exsbowner_bankAccount"
        v-model="item.bankAccount"
        :class="['form-control', isInvalid('bankAccount') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('bankAccount', $event.target.value)">
      <div
        v-if="isInvalid('bankAccount')"
        class="invalid-feedback">{{ violations.bankAccount }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbowner_smsKey"
        class="form-control-label">smsKey</label>
      <input
        id="exsbowner_smsKey"
        v-model="item.smsKey"
        :class="['form-control', isInvalid('smsKey') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('smsKey', $event.target.value)">
      <div
        v-if="isInvalid('smsKey')"
        class="invalid-feedback">{{ violations.smsKey }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbowner_logo"
        class="form-control-label">logo</label>
      <input
        id="exsbowner_logo"
        v-model="item.logo"
        :class="['form-control', isInvalid('logo') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('logo', $event.target.value)">
      <div
        v-if="isInvalid('logo')"
        class="invalid-feedback">{{ violations.logo }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbowner_ownerType"
        class="form-control-label">ownerType</label>
      <input
        id="exsbowner_ownerType"
        v-model="item.ownerType"
        :class="['form-control', isInvalid('ownerType') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('ownerType', $event.target.value)">
      <div
        v-if="isInvalid('ownerType')"
        class="invalid-feedback">{{ violations.ownerType }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbowner_onBehalfStatus"
        class="form-control-label">onBehalfStatus</label>
      <input
        id="exsbowner_onBehalfStatus"
        v-model="item.onBehalfStatus"
        :class="['form-control', isInvalid('onBehalfStatus') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('onBehalfStatus', $event.target.value)">
      <div
        v-if="isInvalid('onBehalfStatus')"
        class="invalid-feedback">{{ violations.onBehalfStatus }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbowner_onBehalfEmail"
        class="form-control-label">onBehalfEmail</label>
      <input
        id="exsbowner_onBehalfEmail"
        v-model="item.onBehalfEmail"
        :class="['form-control', isInvalid('onBehalfEmail') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('onBehalfEmail', $event.target.value)">
      <div
        v-if="isInvalid('onBehalfEmail')"
        class="invalid-feedback">{{ violations.onBehalfEmail }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbowner_replyToEmail"
        class="form-control-label">replyToEmail</label>
      <input
        id="exsbowner_replyToEmail"
        v-model="item.replyToEmail"
        :class="['form-control', isInvalid('replyToEmail') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('replyToEmail', $event.target.value)">
      <div
        v-if="isInvalid('replyToEmail')"
        class="invalid-feedback">{{ violations.replyToEmail }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbowner_longitude"
        class="form-control-label">longitude</label>
      <input
        id="exsbowner_longitude"
        v-model="item.longitude"
        :class="['form-control', isInvalid('longitude') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('longitude', $event.target.value)">
      <div
        v-if="isInvalid('longitude')"
        class="invalid-feedback">{{ violations.longitude }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbowner_latitude"
        class="form-control-label">latitude</label>
      <input
        id="exsbowner_latitude"
        v-model="item.latitude"
        :class="['form-control', isInvalid('latitude') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('latitude', $event.target.value)">
      <div
        v-if="isInvalid('latitude')"
        class="invalid-feedback">{{ violations.latitude }}</div>
    </div>

    <button
      type="submit"
      class="btn btn-primary">Submit</button>
  </form>
</template>

<script>
export default {
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    }
  },

  methods: {
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
